<script>
export default {
  inject: ['$axios'],
  props: {
    registryStatus: Boolean,
    onlineStatus: Boolean,
    appUpdatingStatus: Boolean,
    appUpdatedStatus: Boolean,
    appVersionNumber: String,
    loginMsg: String,
    registerSuccessMsg: String,
    registerFailMsg: String,
    signIn: Boolean,
    forgotPass: Boolean,
    reminderSuccessMsg: String,
    reminderFailMsg: String
  },
  data() {
    return {
      updateText: '',
      updateTextSpinner: '',

      emailRegex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
      passwordRegex: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/,

      loginEmail: {
        value: "",
        error: false
      },
      loginPassword: {
        value: "",
        error: false
      },

      passReminderEmail: {
        value: "",
        error: false
      },


      firstName: "",
      lastName: "",
      registryEmail: {
        value: "",
        error: false
      },
      registryPassword: {
        value: "",
        error: false
      },
      confirmPassword: {
        value: "",
        error: false
      },

      loginProcessing: false,

      inputType: 'password',

      checkingUpdates: true,
      showRefreshButton: false,
      serverVersionMismatch: false
    };
  },
  methods: {
    showPassword() {
      let vm = this;
      if (vm.inputType === 'password') {
        vm.inputType = 'text';
      } else {
        vm.inputType = 'password';
      }
    },
    reloadApp() {
      location.reload();
    },
    signInToggle(signInState) {
      let vm = this;
      vm.$emit('resetPageEmission', {signInState: signInState});
    },
    activatePassReminder() {
      let vm = this;
      vm.$emit('resetPassEmission', {});
    },
    validateLoginEmail() {
      this.loginEmail.error = this.loginEmail.value === "";
    },
    validatePassReminderEmail() {
      this.passReminderEmail.error = this.passReminderEmail.value === "";
    },
    validateLoginPassword() {
      this.loginPassword.error = this.loginPassword.value === "";
    },
    validateRegistrationEmail() {
      this.registryEmail.error = this.registryEmail.value === "";
    },
    validateRegistryPassword() {
      this.registryPassword.error = this.registryPassword.value === "";
    },
    onLoginSubmit() {
      let vm = this;
      if (vm.loginProcessing) {
        console.error('Login in progress');
      } else {
        try {
          vm.loginProcessing = true;
          vm.$axios
              .post('/auth/user/login', {
                email: vm.loginEmail.value,
                password: vm.loginPassword.value,
              }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then(function (response) {
                if (response.data.success) {
                  localStorage.setItem("account", JSON.stringify(response.data.account));
                  localStorage.setItem("location", JSON.stringify(response.data.location));
                  localStorage.setItem("preapproval", JSON.stringify(response.data.preapproval));
                  localStorage.setItem("relations", JSON.stringify(response.data.relations));
                  vm.$emit('loginEmission', {status: true, loginData: response.data.account});
                } else {
                  vm.$emit('loginEmission', {status: false, reason: response.data.msg});
                }
                vm.loginProcessing = false;
              })
        } catch (error) {
          console.error(error);
          vm.loginProcessing = false;
        }
      }
    },
    onPasswordReminderSubmit() {
      let vm = this;
      try {
        vm.$axios
            .post('/auth/user/passwordReminder', {
              email: vm.passReminderEmail.value
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(function (response) {
              if (response.data.success) {
                vm.$emit('passwordResetEmission', {status: true, reminderData: response.data.msg});
              } else {
                vm.$emit('passwordResetEmission', {status: false, reason: response.data.msg});
              }
            })
      } catch (error) {
        console.error(error);
      }
    },
    onRegisterSubmit() {
      let vm = this;
      try {
        vm.$axios
            .post('/auth/user/register', {
              fname: vm.firstName,
              lname: vm.lastName,
              email: vm.registryEmail.value,
              password: vm.registryPassword.value,
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(function (response) {
              if (response.data.success) {
                vm.$emit('registryEmission', {status: true, registrationData: response.data.msg});
              } else {
                vm.$emit('registryEmission', {status: false, reason: response.data.msg});
              }
            })
      } catch (error) {
        console.error(error);
      }
    }
  },
  mounted() {
    let vm = this;
    vm.$axios
        .post(`/auth/app/${vm.appVersionNumber}`, {}, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          if (response.data.success) {
            vm.checkingUpdates = false;
          } else {
            vm.serverVersionMismatch = true;
          }
        })


  },
  computed: {
    appIsRegistered() {
      let vm = this;
      if (vm.registryStatus) {
        return 'App Registered';
      } else {
        return 'App Not Registered';
      }
    },
    appIsOnline() {
      let vm = this;
      if (vm.onlineStatus) {
        return 'Online';
      } else {
        return 'Offline';
      }
    },
    appIsUpToDate() {
      let vm = this;
      if (vm.appUpdatingStatus) {
        vm.updateText = 'Downloading Update';
        return vm.updateText;
      } else {
        if (vm.updateText === 'Downloading Update') {
          vm.updateText = 'Update Downloaded';
        } else {
          vm.updateText = 'Latest App Running';
        }
        return vm.updateText;
      }
    },
    appVersionChecking() {
      let vm = this;
      if (vm.appUpdatingStatus) {
        vm.updateTextSpinner = 'Downloading Update';
        return vm.updateTextSpinner;
      } else {
        if (vm.updateTextSpinner === 'Downloading Update') {
          vm.updateTextSpinner = 'Update Downloaded';
        } else {
          if (vm.serverVersionMismatch) {
            vm.updateTextSpinner = 'Update found';
            vm.showRefreshButton = true;
          } else {
            vm.updateTextSpinner = 'Checking for updates';
          }

        }
        return vm.updateTextSpinner;
      }
    },
    refreshAppNow() {
      let vm = this;
      return !!vm.appUpdatedStatus;
    },
    loginEmailValid() {
      return this.emailRegex.test(this.loginEmail.value);
    },
    validatePassReminderValid() {
      return this.emailRegex.test(this.passReminderEmail.value);
    },
    loginPasswordValid() {
      return this.loginPassword.value.length > 0;
    },

    validFirstName() {
      return this.firstName.length > 0;
    },

    validLastName() {
      return this.lastName.length > 0;
    },
    registrationEmailValid() {
      return this.emailRegex.test(this.registryEmail.value);
    },
    registrationPasswordValid() {
      return (this.registryPassword.value === this.confirmPassword.value) && (this.registryPassword.value.length > 0);
    },

    loginValid() {
      return this.loginEmailValid && this.loginPasswordValid;
    },
    passReminderValid() {
      return this.validatePassReminderValid;
    },

    registerValid() {
      return (
          this.registrationEmailValid &&
          this.registrationPasswordValid &&
          this.validFirstName &&
          this.validLastName
      );
    }
  },
  watch: {
    signIn: {
      handler: function (newValue) {
        let vm = this;
        if (newValue) {
          vm.firstName = '';
          vm.lastName = '';
          vm.registryEmail = {
            value: '',
            error: false
          };
          vm.registryPassword = {
            value: '',
            error: false
          };
          vm.confirmPassword = {
            value: '',
            error: false
          };
        } else {
          vm.loginEmail = {
            value: '',
            error: false
          };
          vm.loginPassword = {
            value: '',
            error: false
          };
        }
      },
      deep: true
    }
  }
};

</script>

<template>
  <div id="page-style">
    <div class="app-version top-version-text">{{ appIsRegistered }} <span class="pipe-divider">|</span> {{
        appIsOnline
      }}
    </div>
    <div class="loginBox">
      <div class="inner">

        <div class="top">
          <div class="title">
            <span class="AMH-darkGray-text">S</span>
            <span class="AMH-darkGray-text">.</span>
            <safe class="AMH-darkGray-text">A</safe>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">F</span>
            <span class="AMH-darkGray-text">.</span>
            <span class="AMH-darkGray-text">E</span>
            <span class="AMH-darkGray-text">.</span>
          </div>
          <img alt="AMH logo" src="../assets/icon.png" class="logo">
        </div>

        <div v-if="checkingUpdates" class="check-version-container">
          <div class="check-version"></div>
          {{ appVersionChecking }}

          <a v-if="refreshAppNow || showRefreshButton" class="button is-rounded is-small refresh-btn"
             v-on:click="reloadApp">Reload</a>
        </div>
        <div v-else>
          <div class="signIn" v-if="signIn">
            <div class="title">Sign in</div>
            <div class="subtitle form-subtitle">
              Don't have an account?
              <span class="subtitle-action" @click="signInToggle(signIn)">
                Create Account
              </span>
            </div>
            <form v-on:submit.prevent="onLoginSubmit">
              <div class="form">
                <input
                    required
                    aria-required="true"
                    aria-invalid="false"
                    aria-label="E-mail"
                    type="email"
                    class="w100"
                    :class="{ invalid: loginEmail.error }"
                    ref="email"
                    placeholder="Email"
                    autofocus
                    @blur="validateLoginEmail"
                    @keydown="validateLoginEmail"
                    v-model="loginEmail.value"
                />
              </div>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input class="input"
                         v-bind:type="inputType"
                         required
                         aria-required="true"
                         :class="{ invalid: loginPassword.error }"
                         placeholder="Password"
                         v-model="loginPassword.value"
                         @blur="validateLoginPassword"
                         @keydown="validateLoginPassword">
                </div>
                <div class="control">
                  <div class="button is-light pass-view-btn" v-on:click="showPassword">
                    <font-awesome-icon :icon="['fas', 'eye']" v-if="inputType==='password'"/>
                    <font-awesome-icon :icon="['fas', 'eye-slash']" v-if="inputType==='text'"/>
                  </div>
                </div>
              </div>
              <div v-if="loginMsg.length>0" class="has-text-danger login-error">
                <font-awesome-icon :icon="['fas', 'triangle-exclamation']"/>
                {{ loginMsg }}
              </div>
              <input
                  type="submit"
                  value="Login"
                  class="action login-btn"
                  :class="{ 'action-disabled': !loginValid || loginProcessing }"
              />
            </form>
            <div class="forgot-pass-link" @click="activatePassReminder()">Forgot Password</div>
          </div>

          <div class="signIn" v-else-if="forgotPass">
            <div class="title">Forgot Password</div>
            <div class="subtitle form-subtitle">
              Remembered your password?
              <span class="subtitle-action" @click="signInToggle(signIn)">
                Sign In
              </span>
            </div>
            <div v-if="reminderSuccessMsg.length>0" class="title">
              <div class="subtitle has-text-success">
                <font-awesome-icon :icon="['fas', 'thumbs-up']"/>
                {{ reminderSuccessMsg }}
                <div class="subtitle-action success-reg-link" @click="signInToggle(signIn)">
                  Proceed to Sign In
                </div>
              </div>
            </div>
            <form v-else v-on:submit.prevent="onPasswordReminderSubmit">
              <div class="form">
                <input
                    required
                    aria-required="true"
                    aria-invalid="false"
                    aria-label="E-mail"
                    type="email"
                    class="w100"
                    :class="{ invalid: passReminderEmail.error }"
                    ref="email"
                    placeholder="Email"
                    autofocus
                    @blur="validatePassReminderEmail"
                    @keydown="validatePassReminderEmail"
                    v-model="passReminderEmail.value"
                />

              </div>
              <div v-if="reminderFailMsg.length>0" class="has-text-danger login-error">
                <font-awesome-icon :icon="['fas', 'triangle-exclamation']"/>
                {{ reminderFailMsg }}
              </div>
              <input
                  type="submit"
                  value="Send Reminder"
                  class="action"
                  :class="{ 'action-disabled': !passReminderValid }"
              />
            </form>
          </div>

          <div class="register" v-else>
            <div class="title" v-if="registerSuccessMsg.length===0">Create an Account</div>
            <div class="subtitle form-subtitle" v-if="registerSuccessMsg.length===0">
              Already have an account?
              <span class="subtitle-action" @click="signInToggle(signIn)">
                Sign In
              </span>
            </div>
            <div v-if="registerSuccessMsg.length>0" class="title">
              <div class="subtitle has-text-success">
                <font-awesome-icon :icon="['fas', 'thumbs-up']"/>
                {{ registerSuccessMsg }}
                <div class="subtitle-action success-reg-link" @click="signInToggle(signIn)">
                  Proceed to Sign In
                </div>
              </div>
            </div>
            <form v-else v-on:submit.prevent="onRegisterSubmit">
              <div class="form">
                <input
                    type="text"
                    placeholder="First name"
                    autofocus
                    v-model="firstName"
                    class="w100"
                />

                <input
                    type="text"
                    placeholder="Last name"
                    v-model="lastName"
                    class="w100"
                />

                <input
                    type="text"
                    class="w100"
                    placeholder="Email"
                    @blur="validateRegistrationEmail"
                    @keydown="validateRegistrationEmail"
                    v-model="registryEmail.value"
                />
                <input
                    type="password"
                    class="w100"
                    placeholder="Password"
                    v-model="registryPassword.value"
                    @blur="validateRegistryPassword"
                    @keydown="validateRegistryPassword"
                />
                <input
                    type="password"
                    class="w100"
                    placeholder="Confirm Password"
                    v-model="confirmPassword.value"
                />
              </div>

              <div v-if="registerFailMsg.length>0" class="has-text-danger register-error">
                <font-awesome-icon :icon="['fas', 'triangle-exclamation']"/>
                {{ registerFailMsg }}
              </div>


              <button class="action" :class="{ 'action-disabled': !registerValid }">
                Create Account
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="app-version bottom-version-text">Surgical Access For Everyone <span class="pipe-divider">|</span>
      {{ appVersionNumber }}
    </div>
  </div>
</template>

<style lang="scss">

.AMH-transitionGray-text {
  color: #767576 !important;
}

.AMH-darkGray-text {
  color: #221f20 !important;
}

.AMH-blue-text {
  color: #276eb6 !important;
}

.AMH-red-text {
  color: #ce3727 !important;
}

.AMH-yellow-text {
  color: #f8d246 !important;
}

.AMH-green-text {
  color: #4d9041 !important;
}

.top-version-text, .bottom-version-text {
  background-color: white;
}

.top-version-text {
  border-radius: 15px 15px 0 0;
}

.bottom-version-text {
  border-radius: 0 0 15px 15px;
}

.forgot-pass-link {
  margin-top: 10px;
  color: green;
  font-weight: bold;
  cursor: pointer;
}

.refresh-btn {
  margin-left: 10px;
}

.login-error, .register-error {
  height: 40px;
  padding: 10px;
  margin-top: 20px;
}

.success-reg-link {
  margin-top: 20px;
}

@mixin box {
  box-shadow: 1px 1px 2px 1px #ccc;
}

@mixin field {
  border: 1px solid #aaa;
  height: 40px;
  padding: 10px;
  margin-top: 20px;
  border-radius: 5px;
  box-sizing: border-box;
}

input[type="text"] {
  @include field;
}

input[type="email"] {
  @include field;
}

input[type="password"] {
  @include field;
}

.invalid {
  border: 2px solid red !important;

  &::placeholder {
    color: red;
  }
}

.errorMessage {
  color: red;
  margin: 10px;
  top: 5px;
}

.w100 {
  width: 100%;
}

#app {
}

.logo {
  width: 300px;
  margin-bottom: 10px;
}

.action {
  height: 40px;
  text-transform: uppercase;
  border-radius: 25px;
  width: 100%;
  border: none;
  cursor: pointer;
  background: green;
  margin-top: 20px;
  color: #fff;
  font-size: 1.2rem;
  @include box;
}

.action-disabled {
  color: #eee;
  background: #aaa;
  cursor: auto;
}

.top {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 10px;
}

.title {
  width: 100%;
  font-size: 1.8rem;
  margin-bottom: 10px;
  text-align: center;
}

.subtitle {
  .subtitle-action {
    color: green;
    font-weight: bold;
    cursor: pointer;
  }
}

.form-subtitle {
  margin-bottom: 0 !important;
}

.page-style {
  background: linear-gradient(
          to bottom,
          rgba(96, 108, 136, 1) 0%,
          rgba(63, 76, 107, 1) 100%
  ) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
}

.loginBox {
  background: rgba(244, 244, 244, 0.9);
  max-width: 500px;
  padding: 25px 55px;
  animation: slideInTop 1s;
}

@keyframes slideInTop {
  from {
    opacity: 0;
    transform: translateY(-30%);
  }

  to {
    opacity: 100;
    transform: translateY(0%);
  }
}

@media screen and (min-width: 440px) {
  .loginBox {
    @include box;
  }
}

@media screen and (max-width: 440px) {
  html {
    background: #fff;
    align-items: start;
    justify-content: start;
  }

  .loginBox {
    padding: 25px 25px;
    max-width: 100vw;
  }
}

.pass-view-btn {
  margin-top: 20px;
  border: 1px solid #aaa !important;
  height: 40px !important;
  border-radius: 0 5px 5px 0 !important;
  box-sizing: border-box;
}


.check-version {
  background-image: url("../assets/img/colorful-spinner.png");
  background-size: cover;
  animation: animName 2s linear infinite;
  width: 50px;
  height: 50px;
  margin: 20px;
}

@keyframes animName {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.check-version-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.pipe-divider {
  font-weight: bolder;
}

</style>
